import { Field, TextInput, TextAreaInput, IMessageProps } from 'Components/Core';
import { PageSection, SectionGroup, ListFieldSection } from 'Components/Layout';
import { useDispatch, useSelector } from 'react-redux';
import { ListDropdown } from 'Components/List';
import { IAgsExportConfiguration } from './types';
import { useState } from 'react';
import { actions } from 'Data/ReduxViewModels/Admin';
import { ISelectOption } from 'Components/Core/Dropdown/types';
import { AgsExportConfigurationRunExportAdmin } from './Core/AgsExportConfigurationRunExportAdmin';

const AgsExportConfigurationAdmin = () => {
  const dispatch = useDispatch();

  const data: IAgsExportConfiguration = useSelector((state: any) => state.admin.syncModel);
  const [baseConfigurationValue, setBaseConfigurationValue] = useState<ISelectOption | null>(
    data.BaseConfigurationUUID
      ? {
          value: data.BaseConfigurationUUID.toString(),
          label: data.BaseConfigurationName ?? '',
        }
      : null
  );
  const [nameFieldMessages, setNameFieldMessages] = useState<any>([]);

  const dropDownOnChange = (evt: any) => {
    var selectedOption = evt.data.value;
    setBaseConfigurationValue(selectedOption && { value: selectedOption.value, label: selectedOption.label });
    dispatch(actions.setValue({ name: evt.data.name, value: selectedOption?.value, sync: true }));
  };

  const nameFieldOnChange = (evt: any) => {
    let submit: boolean = evt.data.submitValues;

    if (!evt.data.value || evt.data.value.length === 0) {
      submit = false;
      setNameFieldMessages([{ severity: 'error', message: 'Name cannot be empty' }]);
    } else {
      setNameFieldMessages([]);
    }

    dispatch(actions.setValue({ name: evt.data.name, value: evt.data.value, sync: submit }));
  };

  const baseConfigurationUUIDMessages: IMessageProps[] | undefined = data.Messages?.filter(
    (m: any) => m.PropertyName === 'BaseConfiguration'
  ).map((m: any) => ({
    message: m.Text,
    severity: m.MessageType.toLowerCase(),
  }));

  const contentMessages: IMessageProps[] | undefined = data.Messages?.filter(
    (m: any) => m.PropertyName === 'Content'
  ).map((m: any) => ({
    message: m.Text,
    severity: m.MessageType.toLowerCase(),
  }));

  return (
    <>
      <PageSection heading="Details">
        <SectionGroup>
          <ListFieldSection wide={data.IsStandardConfiguration}>
            <Field
              input={<TextInput />}
              label="Name"
              name="syncModel.Name"
              maxLength={100}
              disabled={data.IsStandardConfiguration}
              onChange={nameFieldOnChange}
              messages={nameFieldMessages}
            />
            <Field
              input={<ListDropdown />}
              label="Base Configuration"
              visible={!data.IsStandardConfiguration}
              name="syncModel.BaseConfigurationUUID"
              queryParams={{ AgsVersion: data.AgsVersion }}
              endpoint="list.ags.exportConfigurations"
              disabledOptions={[data.Id]}
              value={baseConfigurationValue}
              onChange={dropDownOnChange}
              messages={baseConfigurationUUIDMessages}
            />
          </ListFieldSection>
          <ListFieldSection wide>
            <Field
              input={<TextAreaInput />}
              label="XML Configuration"
              name="syncModel.Content"
              rows={20}
              disabled={data.IsStandardConfiguration}
              messages={contentMessages}
              copyContentToClipboardLabel="Copy XML configuration content to clipboard"
            />
          </ListFieldSection>
        </SectionGroup>
      </PageSection>
      <AgsExportConfigurationRunExportAdmin
        configurationId={data.Id}
        workOrderUUID={data.WorkOrderUUID?.toString()}
        workOrderName={data.WorkOrderName}
      />
    </>
  );
};

export default AgsExportConfigurationAdmin;
export { AgsExportConfigurationAdmin };
